import React from "react";
import phone from "../../asset/landing_images/landing-phone.webp";
// import search from "../asset/landing-search.png";

const LandingMoments = () => {
  const isTabletOrMobile = window.innerWidth <= 1024;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: isTabletOrMobile ? "column" : "row",
        justifyContent: isTabletOrMobile ? "center" : "space-evenly",
        alignItems: "center",
        textAlign: isTabletOrMobile ? "center" : "left",
        // marginTop: isTabletOrMobile ? "" : "",
        padding: isTabletOrMobile ? "0 1rem" : "0",
      }}
    >
      <div>
        <img
          src={phone}
          style={{
            height: isTabletOrMobile ? "18rem" : "30rem",
            marginTop: isTabletOrMobile ? "1.5rem" : "0",
          }}
          alt="Phone Display"
        />
      </div>

      <div>
        <h1
          style={{
            color: "#30CDD8",
            marginBottom:'2rem',
            textAlign: isTabletOrMobile ? "center" : "left",
          }}
        >
          Showcase Your Moments <br /> With{" "}
          <span style={{ color: "#000", fontWeight: "bold" }}>Photos</span> and{" "}
          <span style={{ color: "#000", fontWeight: "bold" }}>Reels</span>
        </h1>
        <p
          style={{
            textAlign: isTabletOrMobile ? "center" : "left",
            marginTop: isTabletOrMobile ? "0" : "-1.3rem",
          }}
        >
          Upload multiple photos with easy drag-and-drop. <br />
          Share short video reels from your favorite hosting sites. <br />
          Tag friends in photos and videos to keep the conversation going.
        </p>
        <a href="https://www.youthplus.ng" style={{textDecoration:'none', }} target="blank">
        <button
          style={{
            color: "#4E99DD",
            border: "2px solid #4E99DD",
            backgroundColor: "#fff",
            borderRadius: "8px",
            padding: isTabletOrMobile ? "15px" : "20px",
            marginTop: isTabletOrMobile ? "1rem" : "0",
          }}
        >
          Learn more
        </button></a>
      </div>
    </div>
  );
};

export default LandingMoments;
